/** Itens por página com que toda listagem paginada abre; o `pageSize` de uma chamada sem tamanho informado também. */
export const DEFAULT_PAGE_SIZE = 20;
/** Opções do seletor de itens por página; inclui o `DEFAULT_PAGE_SIZE`. */
export const PAGE_SIZE_OPTIONS: readonly number[] = [10, 20, 50];
